"use strict";
var quantitySelectorButtons = document.querySelectorAll('.quantity-selector button');
quantitySelectorButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
        var _a, _b, _c;
        (_c = (_b = (_a = button.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.querySelector(".update-totals")) === null || _c === void 0 ? void 0 : _c.classList.remove("d-none");
    });
});
var updateTotalsButtons = document.querySelectorAll('.update-totals');
updateTotalsButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
        var _a;
        event.preventDefault();
        var input = (_a = button.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('input');
        if (input) {
            var value = parseInt(input.value);
            var index = parseInt(input.getAttribute('data-itemIndex') || "0");
            fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ line: index, quantity: value })
            }).then(function () {
                window.location.reload();
            });
        }
    });
});
